import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'dialog-draggable-header',
  templateUrl: './dialog-draggable-header.component.html',
  styleUrls: ['./dialog-draggable-header.component.scss']
})
export class DialogDraggableHeaderComponent {
  constructor() { }
}
